<template>
  <div class="card">
    <form id="createGoalForm" class="form-horizontal">
      <div class="card-header">
        <h4 class="card-title">
          Goal Form
        </h4>
      </div>
      <div class="card-content">
        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Target Amount</label>
            <div class="col-sm-6">
              <input type="number"
                     name="targetAmount"
                     data-vv-as="Target Amount"
                     v-validate="modelValidations.targetAmount"
                     v-model="model.targetAmount"
                     class="form-control">
              <small class="text-danger" v-show="targetAmount.invalid">
                {{ getError('targetAmount') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Description</label>
            <div class="col-sm-6">
              <input type="text"
                     name="description"
                     data-vv-as="Description"
                     v-validate="modelValidations.description"
                     v-model="model.description"
                     class="form-control">
              <small class="text-danger" v-show="description.invalid">
                {{ getError('description') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Due Date</label>
            <div class="col-sm-6">
              <el-date-picker
                name="goalDueDate"
                data-vv-as="Goal Due Date"
                v-validate="modelValidations.goalDueDate"
                v-model="model.goalDueDate"
                type="datetime"
                placeholder="Select date and time" 
                :picker-options="pickerOptions1"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <small class="text-danger" v-show="goalDueDate.invalid">
                {{ getError('goalDueDate') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Start Date</label>
            <div class="col-sm-6">
              <el-date-picker
                name="goalStartDate"
                data-vv-as="Goal Start Date"
                v-validate="modelValidations.goalStartDate"
                v-model="model.goalStartDate"
                type="datetime"
                placeholder="Select date and time" 
                :picker-options="pickerOptions1"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <small class="text-danger" v-show="goalStartDate.invalid">
                {{ getError('goalStartDate') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Saved Amount</label>
            <div class="col-sm-6">
              <input type="number"
                     name="savedAmount"
                     data-vv-as="Saved Amount"
                     v-validate="modelValidations.savedAmount"
                     v-model="model.savedAmount"
                     class="form-control">
              <small class="text-danger" v-show="savedAmount.invalid">
                {{ getError('savedAmount') }}
              </small>
            </div>
          </div>
        </fieldset>

      </div>
      <div class="card-footer">
        <p-button type="info" @click.prevent="validate" class="info" round>{{ model.saveGoalButtonText }}</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
    },
    computed: {
      ...mapFields(['description', 'targetAmount', 'savedAmount', 'goalDueDate', 'goalStartDate'])
    },
    data () {
      return {
        
        model: {
          description: '',
          targetAmount: '',
          goalDueDate: '',
          goalStartDate: '',
          savedAmount: '',
          saveGoalButtonText: 'Save Goal',
        },
        modelValidations: {
          description: {
            required: true
          },
          targetAmount: {
            required: true,
            decimal: true
          },
          savedAmount: {
            required: true,
            decimal: true
          },
          goalDueDate: {
            required: true,
          },
          goalStartDate: {
            required: true,
          },
        },
        selects: {
         
        },
        pickerOptions1: {
          shortcuts: [{
            text: 'Today',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: 'Yesterday',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: 'A week ago',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },

      validate () {
        this.$validator.validateAll().then(isValid => {
          if(isValid){
            
            this.$emit('on-submit', this.model, isValid, this.$validator)
          }
        })
      },
      editViewCheck () {
       
        if(this.$route.name == 'Update Goal'){

          this.$http.get('/goals/' + this.$route.params.id)
          
          .then(response => {
            var goalDetails = response.data

            this.model.description = goalDetails.description
            this.model.targetAmount = goalDetails.amount / 100
            this.model.savedAmount = goalDetails.saved / 100

            this.model.goalDueDate = goalDetails.due_date
            this.model.goalStartDate = goalDetails.start_date
          
          })
          .catch(err => console.error(err))
          }
      }
    },

    mounted () {
      this.editViewCheck(),
      this.fetchCategories ()
      
    },
    
    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>
<style>
  #createGoalForm .el-select { display: block  !important;}
</style>
